// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Level Layout & Route Fallback Styles */

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.app-container > * {
  width: 100%;
}

.home-iframe-container {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.home-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.app-route-fallback-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: var(--brand-cyan, #1490A4);
  gap: 1rem;
}

.app-route-spinner {
  width: 38px;
  height: 38px;
  border: 3px solid rgba(20, 144, 164, 0.2);
  border-top-color: var(--brand-cyan, #1490A4);
  border-radius: 50%;
  animation: appSpinnerRotate 0.8s linear infinite;
}

@keyframes appSpinnerRotate {
  to {
    transform: rotate(360deg);
  }
}

/* Chatbot widget loading state */
.chatbot-loading {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--brand-cyan, #1490A4);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 999;
  animation: chatbotPulse 1.5s ease-in-out infinite;
}

.chatbot-loading::after {
  content: '';
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: chatbotSpin 0.8s linear infinite;
}

@keyframes chatbotPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

@keyframes chatbotSpin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,4CAA4C;EAC5C,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* App Level Layout & Route Fallback Styles */\n\n.app-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.app-container > * {\n  width: 100%;\n}\n\n.home-iframe-container {\n  width: 100%;\n  height: 100vh;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.home-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.app-route-fallback-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  color: var(--brand-cyan, #1490A4);\n  gap: 1rem;\n}\n\n.app-route-spinner {\n  width: 38px;\n  height: 38px;\n  border: 3px solid rgba(20, 144, 164, 0.2);\n  border-top-color: var(--brand-cyan, #1490A4);\n  border-radius: 50%;\n  animation: appSpinnerRotate 0.8s linear infinite;\n}\n\n@keyframes appSpinnerRotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Chatbot widget loading state */\n.chatbot-loading {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--brand-cyan, #1490A4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  z-index: 999;\n  animation: chatbotPulse 1.5s ease-in-out infinite;\n}\n\n.chatbot-loading::after {\n  content: '';\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: chatbotSpin 0.8s linear infinite;\n}\n\n@keyframes chatbotPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n@keyframes chatbotSpin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
